import React from 'react'
import { Flex, TextBox, DesktopBlock, Box, Picture, MobileBlock } from 'landing/kit'
import mainPictPng from 'landing/assets/images/main-pict.png'
import mainPictWebp from 'landing/assets/images/main-pict.webp'
import mainPictMobPng from 'landing/assets/images/main-pict-mob.png'
import mainPictMobWebp from 'landing/assets/images/main-pict-mob.webp'


import { H2 } from 'landing/components/home/styles'

const IntroBlock = () => {

  return (
    <>
      <MobileBlock>
        <Box css={{ background: '#fff' }} pb="50px">
          <Flex flexDirection="column" alignItems="center" px="16px" mb={110}>
            <Flex>
              <Picture
                src={mainPictMobPng}
                webpSrc={mainPictMobWebp}
                width="316px"
                height="364px"
                loading="lazy"
              />
            </Flex>
            <Flex px={16} flexDirection="column" width="100%">
              <H2 fontWeight={800} color="secondaryLight" mt={10} mb={12}>
                Who we are
              </H2>
              <TextBox fontSize={24} lineHeight={1.3} color="secondaryLight" mb={39}>
                We automate sourcing, updating and shortlisting candidates to help recruiters find the best talent up to
                80% faster. Our ATS integration automatically keeps candidate information up-to-date, enriches profiles
                with skills and experience from 30+ sources, and identifies the right people for the role.
              </TextBox>
            </Flex>
          </Flex>
        </Box>
      </MobileBlock>
      <DesktopBlock>
        <Box css={{ background: '#fff' }} pb="50px">
          <Box width={1137} mx="auto">
            <Flex flexDirection="row">
              <Flex flexDirection="column" justifyContent="center">
                <Box mr="55px" mt="-60px">
                  <H2 fontWeight={800} textAlign="left" maxWidth={575} color="secondaryLight" mb="20px">
                    Who we are
                  </H2>
                  <TextBox fontSize={24} lineHeight="34px" color="secondaryLight" css={{ maxWidth: '487px' }} mb="50px">
                    We automate sourcing, updating and shortlisting candidates to help recruiters find the best talent up to
                    80% faster. Our ATS integration automatically keeps candidate information up-to-date, enriches profiles
                    with skills and experience from 30+ sources, and identifies the right people for the role.
                  </TextBox>
                </Box>
              </Flex>
              <Box mb="50px">
                <Picture
                  src={mainPictPng}
                  webpSrc={mainPictWebp}
                  width="472px"
                  height="592px"
                  loading="lazy"
                />
              </Box>
            </Flex>
          </Box>
        </Box>
      </DesktopBlock>
    </>
  )
}

export default IntroBlock
